import module from '@inicio/module'
import template from './template.html'
import './style.scss'

export class InicioComponent {
}

module.component('inicio', {
  controller: InicioComponent,
  template: template,
})



// WEBPACK FOOTER //
// ./src/inicio/components/component.js